import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a9420c9")

_pushScopeId("data-v-6a9420c9")
const _hoisted_1 = { class: "pt-4 bg-white" }
const _hoisted_2 = { id: "suggested-images" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BaseAlertMessage = _resolveComponent("BaseAlertMessage")
  const _component_TextSearchArea = _resolveComponent("TextSearchArea")
  const _component_SuggestedImages = _resolveComponent("SuggestedImages")
  const _component_LimitReachedModal = _resolveComponent("LimitReachedModal")
  const _component_Footer = _resolveComponent("Footer")
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")

  return (_openBlock(), _createBlock(_component_DefaultLayout, { class: "default-layout" }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_TextSearchArea, {
          "search-string": _ctx.searchString,
          "selected-tab": _ctx.selectedTab,
          loading: _ctx.isLoading,
          onSubmit: _ctx.onSubmit,
          onTabChanged: _ctx.onChangeTab
        }, {
          alert: _withId(() => [
            _createVNode(_component_BaseAlertMessage, {
              modelValue: _ctx.noResults,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.noResults = $event)),
              class: "mb-4 py-5"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.no-images')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_BaseAlertMessage, {
              modelValue: _ctx.isError,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isError = $event)),
              class: "mb-4 py-5",
              variant: "danger"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('messages.network-error')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["search-string", "selected-tab", "loading", "onSubmit", "onTabChanged"]),
        _createVNode("div", _hoisted_2, [
          (!_ctx.isInitial)
            ? (_openBlock(), _createBlock(_component_SuggestedImages, {
                key: 0,
                loading: _ctx.isLoading,
                images: _ctx.images,
                "require-auth": _ctx.shoudlRequireAuth
              }, null, 8, ["loading", "images", "require-auth"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_LimitReachedModal, {
          modelValue: _ctx.limitReached,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.limitReached = $event)),
          "selected-search-type": _ctx.selectedTab,
          onRedirect: _ctx.onRedirectToMembership
        }, null, 8, ["modelValue", "selected-search-type", "onRedirect"])
      ]),
      _createVNode(_component_Footer)
    ]),
    _: 1
  }))
})